"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldContext = void 0;
const react_1 = require("react");
exports.FormFieldContext = (0, react_1.createContext)({});
//# sourceMappingURL=form-field-context.js.map